import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: { componentStack: string }) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div className="flex h-screen flex-col items-center justify-center gap-4 px-4 text-center">
          <div className="text-5xl">🐾</div>
          <h1 className="text-2xl font-bold text-gray-800">页面出了点问题</h1>
          <p className="max-w-sm text-gray-500 text-sm">
            {this.state.error?.message ?? '发生了意外错误，请刷新页面重试。'}
          </p>
          <button
            onClick={() => window.location.reload()}
            className="rounded-lg bg-orange-400 px-6 py-2 text-sm font-medium text-white hover:bg-orange-500 transition-colors"
          >
            刷新页面
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
